import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "w-16 h-16 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center"
}
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString($props.label), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      ($props.modelValue)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $props.modelValue,
            class: "h-16 max-w-32 rounded-lg object-contain border border-gray-200"
          }, null, 8 /* PROPS */, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "w-6 h-6 text-gray-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              })
            ], -1 /* CACHED */)
          ]))])),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          onChange: $setup.upload,
          ref: "fileInput",
          class: "hidden"
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$refs.fileInput.click())),
          disabled: $setup.uploading,
          class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
        }, _toDisplayString($setup.uploading ? '...' : ($props.modelValue ? $props.changeText : $props.uploadText)), 9 /* TEXT, PROPS */, _hoisted_6),
        ($props.modelValue)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', ''))),
              class: "ml-2 px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
            }, _toDisplayString($props.removeText), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}